import React from "react";
import styles from './styles.module.scss';
import OptionButton from "app/components/OptionButtonGroup/OptionButton";
import LabelTimeOption from "app/components/OptionButtonGroup/LabelTimeOption";

interface OptionProps {
  day: number;
  value: number;
  label: string;
  short: string;
  active: boolean;
  startTime: string;
  endTime: string;
}

interface OptionButtonProps {
  options: OptionProps[];
  selected: OptionProps[];
  setSelected: any;
  onChange: any;
  shortButtons: boolean;
  step?: number;
  /** Exposes one day's button (by `value`) so the caller can anchor a coachmark to it. */
  anchorDay?: number;
  anchorRef?: React.RefObject<HTMLButtonElement>;
  /** Exposes the row of day buttons, so a press on any day can dismiss that coachmark. */
  groupRef?: React.RefObject<HTMLDivElement>;
}

const OptionButtonGroup = ({
  options,
  selected,
  setSelected,
  onChange,
  shortButtons = false,
  step = 15,
  anchorDay,
  anchorRef,
  groupRef,
}: OptionButtonProps) => {

  return (
    <div>
      <div className={styles.option_button_group} ref={groupRef}>
        {options.map((option) => (
          <OptionButton
            key={option.value}
            ref={option.value === anchorDay ? anchorRef : undefined}
            option={option}
            selected={selected}
            setSelected={setSelected}
            shortButtons={shortButtons}
          />
        ))}
      </div>
      <>
        {selected.map((el) => (
          <LabelTimeOption
            key={el.value}
            index={el.value}
            label={el.label}
            timeFrom={el.startTime}
            timeTo={el.endTime}
            onChange={onChange}
            step={step}
          />
        ))}
      </>
      <div className={styles.horizontal_line} />
    </div>
  );
};

export default OptionButtonGroup;
